import { useGetCart } from "~/hooks/useGetCart"
import type { TVariant } from "~/components/ui/ProductHeader/_data/types"

type CustomVariant = Pick<TVariant, "id" | "price" | "sku" | "vpPrice">

export function useHasReachMaxAvailableQuantity(variants: CustomVariant[]): boolean {
  const { cartPayload } = useGetCart()

  let hasReactMaxQuantities = false

  const isOutOfStock = variants?.some((variant) => {
    const currentLineItem = cartPayload?.lines?.find((lineItem) => lineItem?.merchandise.id === variant?.id)
    return currentLineItem?.merchandise?.quantityAvailable === 0
  })

  variants?.forEach((variant) => {
    const currentLineItem = cartPayload?.lines?.find((lineItem) => lineItem?.merchandise.id === variant?.id)

    if (hasReactMaxQuantities) {
      return
    }

    hasReactMaxQuantities =
      (currentLineItem?.merchandise && currentLineItem?.quantity === currentLineItem?.merchandise?.quantityAvailable) ??
      false
  })

  return isOutOfStock || hasReactMaxQuantities
}
